export default "__VITE_ASSET__DoX2K1EQ__"